import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "footer"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" For more information view the ")
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(", which applies to bank accounts issued by Westpac. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.ADR != null)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _createElementVNode("li", null, " We will never share your login details with " + _toDisplayString(_ctx.ADR.clientName) + " or ask you to provide your real password to share CDR data. ", 1),
        _createElementVNode("li", null, [
          _hoisted_2,
          _createElementVNode("a", {
            class: "add-height",
            href: _ctx.CDR_POLICY_LINK,
            target: "_blank",
            title: "Westpac Consumer Data Right policy"
          }, "Westpac Consumer Data Right (CDR) Policy", 8, _hoisted_3),
          _hoisted_4
        ]),
        _createElementVNode("li", null, " © " + _toDisplayString(_ctx.DH.name) + " " + _toDisplayString(_ctx.DH.abn ? "ABN" : "ACN") + " " + _toDisplayString(_ctx.DH.abn ? _ctx.DH.abn : _ctx.DH.acn), 1)
      ]))
    : _createCommentVNode("", true)
}